import React from 'react';
import ConfigureHolidays from '../../ConfigureHolidays';

const ConfigureHoliday = () => {
  return <ConfigureHolidays embedded />;
};

export default ConfigureHoliday;
